import {excess} from '@fl/cmsch-fe-library';
import * as t from 'io-ts';

export const ValidateUserMembershipErrorsSchema = excess(t.partial({
    approvedFrom: t.string,
    approvedTo: t.string,
    subjectId: t.string,
}));

